import { cn } from '@/common/lib/cn/cn'
import { Icon, type IconName } from '../Icon/Icon'
import './toast.css'

export type ToastContainerProps = {
    children: React.ReactNode
}

export const ToastContainer = ({ children }: ToastContainerProps) => {
    return <div className='toast toast-top toast-end'>{children}</div>
}

export type ToastType = {
    className?: string
    type: 'info' | 'success' | 'error' | 'warning'
    children: React.ReactNode
}

export const Toast = ({ className, children, type }: ToastType) => {
    const iconNameMap: Record<ToastType['type'], IconName> = {
        info: 'info-circle',
        success: 'tick-circle',
        error: 'danger',
        warning: 'danger',
    }
    const iconClassName = cn({
        'text-[#12AAF6]': type === 'info',
        'text-[#29CFB1]': type === 'success',
        'text-[#D3B914]': type === 'warning',
        'text-[#FF484B]': type === 'error',
    })

    return (
        <div
            className={cn(
                'flex w-[242px] flex-col items-start gap-[20px] rounded-[20px] px-[30px] py-[20px] shadow-[0_0_20px_0_rgba(0,0,0,0.35)]',
                className
            )}
            style={{
                backgroundImage:
                    'linear-gradient(127.653deg, rgba(41, 207, 177, 0) 38.26%, rgba(41, 207, 177, 0.06) 83.974%), linear-gradient(90deg, rgb(48, 45, 52) 0%, rgb(48, 45, 52) 100%)',
            }}
        >
            <div className='flex w-full items-center justify-center'>
                {type && <Icon className={iconClassName} name={iconNameMap[type]} size='md' />}
            </div>
            <div className='mx-auto w-full max-w-[182px] text-center text-[14px] font-normal leading-[1.4] text-white'>
                {children}
            </div>
        </div>
    )
}
